import type { TabSelectorProps } from './TabSelector.typed';
import { TabSelectorOption } from './TabSelectorOption/TabSelectorOption';
import * as Styled from './TabSelectorOption/TabSelectorOption.styled';

const TabSelector = (props: TabSelectorProps) => {
  const {
    name,
    disabled = false,
    required,
    hasError = false,
    options,
    selectedOption,
    onTabClick,
  } = props;

  const totalOfTabOptions = options.length;

  return (
    <Styled.TabSelector
      hasError={hasError}
      disabled={disabled}
      data-testid="tab-selector"
    >
      {totalOfTabOptions > 0 &&
        options.map((option) => {
          const isSelected =
            !disabled &&
            !hasError &&
            selectedOption &&
            selectedOption.value === option.value;

          return (
            <TabSelectorOption
              name={name}
              key={option.value}
              selected={isSelected || false}
              value={option.value}
              onClick={() => onTabClick(option.value)}
              required={required}
              hasError={hasError}
              disabled={disabled}
            >
              {option.displayText}
            </TabSelectorOption>
          );
        })}
    </Styled.TabSelector>
  );
};

export { TabSelector };
